module.exports = __webpack_public_path__ + "static/media/4.26605824.jpeg";